import { faSpinnerThird } from '@awesome.me/kit-3f20e419a7/icons/duotone/solid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Card, CardBody, Row } from 'react-bootstrap';

export default function CardWithLoadingIndicator() {
  return (
    <Card>
      <CardBody>
        <Row className="justify-content-center py-5 my-4">
          <FontAwesomeIcon icon={faSpinnerThird} size="3x" spin />
        </Row>
      </CardBody>
    </Card>
  );
}
